import { findIndex, isEqual, pick, slice } from 'lodash';
export const upsertBy = (collection, item, keys) => {
    const index = findIndex(collection, (collectionItem) => isEqual(pick(collectionItem, keys), pick(item, keys)));
    const itemIndex = index === -1 ? collection.length : index;
    return [
        ...slice(collection, 0, itemIndex),
        item,
        ...slice(collection, itemIndex + 1),
    ];
};
export function uniqByKey(array, key) {
    return Array.from(new Map(array.map((item) => [item[key], item])).values());
}
//# sourceMappingURL=array.js.map